import { render, staticRenderFns } from "./ticket-prices-new.vue?vue&type=template&id=ea2ab160&"
import script from "./ticket-prices-new.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports